import {initParallaxSection} from "../components/parallax-section";

export function initKujbyshev1941Landing() {
    if (!$('#kujbyshev1941_landing').length) return;
    initParallaxSection();
}
